module.exports = __webpack_public_path__ + "static/media/testimonial3.ffead712.webp";